(($, Drupal) => {
  $(
    setTimeout(function() {
      // Custom video player.
      const $videoWrapper = $(".video-preview:not('.show-in-modal')");
      $videoWrapper.each(function() {
        var url = $(this).attr("data-video-url");

        $(this).on("click", () => {
          $(this).css("background", "black");
          $(this)
            .find(".btn-play")
            .hide();

          setTimeout(
            $(this)
              .find(".video-player")
              .attr({
                src: url + "?autoplay=1",
                allow: "autoplay; fullscreen; texttrack"
              })
              .show(),
            500
          );
        });
      });
    }),
    1000
  );
})(jQuery, Drupal);
